




import echarts, { EChartOption } from 'echarts'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import ResizeMixin from './mixins/resize'
export interface IPieChartData {
  dealerCode: any[]
}
@Component({
  name: 'PieChart',
})
export default class extends mixins(ResizeMixin) {
  @Prop({ required: true }) private chartTitle!: string
  @Prop({ default: 'chart' }) private className!: string
  @Prop({ default: '100%' }) private width!: string
  @Prop({ default: '350px' }) private height!: string
  @Prop({ required: true }) private dataCharts
  @Watch('dataChart', { deep: true })
  private onChartDataChange(value: IPieChartData) {
    this.setOptions(value)
  }
  // tslint:disable-next-line:member-ordering
  public mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  }
  // tslint:disable-next-line:member-ordering
  public beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  }
  private initChart() {
    this.chart = echarts.init(this.$el as HTMLDivElement, 'macarons')
    this.setOptions(this.dataCharts)
  }
  public getColor(type) {
    switch (type.toLowerCase()) {
      case 'registered':
        return '#808080'
      case 'unregistered':
        return '#ff0000'
      case 'last access within month':
        return '#0000ff'
      case 'no access within month':
        return '#ff0000'
      default:
        return '#333'
    }
  }
  public get colorValue() {
    const array: any = []
    for (const item of this.dataCharts) {
      array.push({
        value: item.value,
        percent: item.percent,
        name: item.name,
        itemStyle: { color: this.getColor(item.name) },
      })
    }
    return array
  }
  public get dealerCode() {
    const array: any = []
    for (const item of this.dataCharts) {
      array.push(item.name)
    }
    return array
  }

  private setOptions(dataChart: IPieChartData) {
    if (this.chart) {
      const dealerData: any = this.dataCharts

      this.chart.setOption({
        fontFamily: 'Roboto Condensed',
        tooltip: {
          trigger: 'item',
          renderMode: 'html',
          formatter: '{b}:{c}',
        },
        title: {
          display: true,
          text: this.chartTitle,
          left: 'center',
        },
        legend: {
          bottom: 'bottom',
          icon: 'circle',
          textStyle: {
            fontSize: 17,
            fontWeight: 'bold',
          },
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 30,
            fontWeight: 'bold',
          },
        },
        labelLine: {
          show: true,
        },
        series: [
          {
            data: this.colorValue,
            itemStyle: { color: '#D6D6D6' },
            type: 'pie',
            radius: '75%',
            label: {
              show: true,
              fontSize: 17,
              color: 'black',
              position: 'inner',
              formatter: '{d} %',
            },
            animationDuration: 2800,
            animationEasing: 'quadraticOut',
          },
        ],
      } as EChartOption<EChartOption.SeriesPie>)
    }
  }
}
